import { Component, ChangeDetectionStrategy, OnInit, Input, Output, EventEmitter, ElementRef, ViewChild, ChangeDetectorRef } from "@angular/core";
import { UserService } from "../_services/user.service";
import { FuseWidgetComponent } from "./widget/widget.component";
import { Router } from "@angular/router";
import { Subscription } from "rxjs";
import { AngularFirestore } from 'angularfire2/firestore';


@Component({
  // tslint:disable-next-line:component-selector
  selector: 'app-post-item',
  templateUrl: './post-item.component.html',
  styleUrls: ['./post-item.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PostItemComponent implements OnInit {
  isSilencedForMe: boolean;
  user: any;
  subs = new Subscription();
  isSeen = true;
  @Input() post: any;
  @Input() whichPage: any;
  @Input() recentPostsLength: any;
  @Output() reload = new EventEmitter();
  @Output() flipped = new EventEmitter();
  @ViewChild(FuseWidgetComponent) widget: ElementRef;
  firstPost: any;
  constructor(private userService: UserService,
    private cd: ChangeDetectorRef,
    private afs: AngularFirestore, private el: ElementRef, public router: Router) {

    this.subs = this.userService.getUser().subscribe(user => {
      this.user = user
    })
    console.log(this.whichPage, 'postitem')






  }

  isSilencedUser(username) {
    try {
      this.afs.collection('users').doc(this.user.id).collection('silencedUser').ref.get().then((data) => {
        let array = [];
        if (!data.empty) {
          data.forEach(silencedUser => {
            array.push(silencedUser.data());

          })
        }

        this.isSilencedForMe = !array.every((data1: any) => username !== data1.username);
        this.cd.markForCheck();
      })

    } catch (e) {

      this.isSilencedForMe = false;
    }
  }
  ngOnInit(): void {

    if (this.post.author) {
      this.isSilencedUser(this.post.author.username)
      this.cd.markForCheck();
    }

    try {

      if (this.post.settings.isNameSecret &&
        this.whichPage == 'user' && this.post.author.username != this.user.username) {
        this.isSeen = false;
      }

      else
        this.isSeen = true;
    } catch (e) { }


  }
  ngOnDestroy() {
    this.subs.unsubscribe();
  }
  flip(event) {
    this.flipped.emit(event);
    this.el.nativeElement.scrollIntoView({ behavior: "smooth", block: "center" });
  }
  goBack() {
    return window.history.back();
  }
}





// WEBPACK FOOTER //
// C:/Users/Lenovo/Desktop/bigadvicefirestore/src/app/post-item/post-item.component.ts